import { useTheme } from '@mui/styles';
import { SelectOption } from '@tassat/common-definitions';
import { muiTheme } from '@tassat/payments-themes';
import { merge } from 'lodash';
import * as React from 'react';
import ReactSelect from 'react-select';

import selectStyles from './styles';
import { StyledSelectProps } from './types';

export default function StyledSelect<Option = SelectOption, IsMulti extends boolean = false, ExtraProps = object>(
    props: StyledSelectProps<Option, IsMulti, ExtraProps>
) {
    const {
        customStyles = {},
        disabled,
        onMenuClose
    } = props;
    const theme = useTheme<typeof muiTheme>();

    const selectRef = React.useRef<any>(null);

    const styles = selectStyles(theme || muiTheme);
    const mergedStyles = React.useMemo(() => merge({}, styles, customStyles), [ styles, customStyles ]);

    const handleMenuClose = () => {
        if (selectRef.current) {
            selectRef.current.blur();
        }
    };

    return (
        <ReactSelect
            {...props}
            isDisabled={disabled}
            onMenuClose={() => {
                handleMenuClose();
                if (onMenuClose) {
                    onMenuClose();
                }
            }}
            ref={selectRef}
            styles={mergedStyles}
        />
    );
}